<template>
  <div>
    <div
      v-if="text.name"
      style="display: flex; align-items: baseline; margin: 10px"
    >
      <div
        style="
          width: 100%;
          height: 3px;
          background-color: #7487c3;
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
        "
      >
        <div style="width: 20px; height: 8px; background-color: #7487c3"></div>
      </div>
      <div
        style="
          width: 100%;
          color: rgba(65, 63, 112, 1);
          font-size: 22px;
          margin: 0 10px;
        "
      >
        <span style="white-space: nowrap">{{ text.name }}</span>
      </div>
      <div
        style="
          width: 100%;
          height: 3px;
          background-color: #7487c3;
          display: flex;
          align-items: flex-end;
        "
      >
        <div style="width: 20px; height: 8px; background-color: #7487c3"></div>
      </div>
    </div>
    <!--v-if="text.tab != '焦虑'"   -->
    <div class="container">
      <div class="back">
        <div class="top">
          <div class="circle-left"></div>
          <div class="circle-right"></div>
        </div>
        <div v-if="text.tab && !isSleepReport" class="title">
          {{ text.tab }}
        </div>
        <div class="content-box">
          <div :class="{ 'content-box-hidden': !showHidContent && !isOldTest }">
            <div v-for="(sub, index) in text.content" :key="index">
              <h1 v-if="sub.subtitle != ''">{{ sub.subtitle }}</h1>
              <span v-for="(para, index) in sub.text" :key="index">
                <span v-if="para[0] == '·'" class="sub">
                  {{ para }}
                </span>
                <p class="para" v-else v-html="changeQuote(para)"></p>
              </span>
              <div v-if="!isOldTest">
                <div v-if="!showHidContent" class="read-more"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="read-more-text" @click="showContent">
          <span v-if="!isOldTest" style="background-color: white">{{
            showText
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../../store";
import { getTestRes, paychase } from "@/http/api";
import "./components/anim.css";
export default {
  props: ["text", "isOldTest", "resultpage_price", "isSleepReport"],
  name: "result_window",
  data() {
    return {
      showHidContent: false,
      showText: "展开全部",
      tmpScrollTop: 0,
      isShow: false,
      showBuy: false,
      userInfo: JSON.parse(localStorage.getItem("vuex")),
      //这是结果页ID
      appraisal_id: "",
      //这是需要支付的费用
      // resultpage_price: -1,
      scrollTop: -1,
      canWatch: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, true);
    // this.appraisal_id = store.state.appraisal_id;
    // getTestRes({
    //   appraisal_id: this.appraisal_id,
    // }).then((res) => {
    //   this.resultpage_price = parseFloat(res.data.resultpage_price);
    // });
  },
  mounted() {
    this.handleScroll();
    console.log(this.text);
  },
  destroyed() {
    this.canWatch = false;
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    goHome() {
      this.$router.push("/index");
    },
    pay() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) != "micromessenger") {
        // if(localStorage['env'] == 'notWechat'){
        let param = {
          pay_type: "resultpage",
          payment: "ali_pay",
          evaluation: this.userInfo.eval_id,
          amount: this.resultpage_price,
          inviter_id: "",
        };
        h5paychase(param).then((res) => {
          if (res.code == "SUCCESS") {
            console.log(res.data.pay_url);
            if (res.data.pay_url) {
              window.location.replace(res.data.pay_url);
            }
            //让页面正常显示
            this.isShow = false;
            this.$parent.isFixed = false;
            this.canWatch = true;
          }
        });
      } else {
        let param = {
          pay_type: "resultpage",
          evaluation: this.userInfo.eval_id,
          amount: this.resultpage_price,
          // amount:0.01,
          inviter_id: "",
          note: this.appraisal_id,
        };
        paychase(param).then((res) => {
          console.log("结果页的支付", res);
          console.log("2021年7月9日10:38:03");
          let data = res.data.pay_params;
          let appId = data.appId;
          let timeStamp = data.timeStamp;
          let nonceStr = data.nonceStr;
          // let signature = data.signature;
          let packages = data.package;
          let paySign = data.paySign;
          // this.code = res.data.redeem_code;
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appId, //公众号名称，由商户传入
              timeStamp: timeStamp, //时间戳，自1970年以来的秒数
              nonceStr: nonceStr, //随机串
              package: packages,
              signType: "MD5", //微信签名方式：
              paySign: paySign, //微信签名
            },
            (res) => {
              console.log(res);
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                this.$message({
                  message: "支付成功",
                  type: "success",
                });
                // let coupon = {
                //     amount: 0,
                //     condition: 0,
                // };
                //让页面正常显示
                this.isShow = false;
                this.$parent.isFixed = false;
                this.canWatch = true;
                // store.commit("set_coupon", coupon);
                // setTimeout(() => {
                //     this.show = false;
                //     this.showCoupon = true;
                //     console.log(this.showCoupon);
                // }, 1000);
              } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                this.$message({
                  message: "您已取消支付",
                  type: "error",
                });
              } else {
                this.$message({
                  message: "支付失败",
                  type: "error",
                });
              }
            }
          );
        });
      }

      // }

      // }
    },
    handleScroll(e) {
      console.log("2021年7月9日15:12:35");
      console.log(e.target.scrollTop);
      this.scrollTop = e.target.scrollTop;
      if (this.scrollTop >= 300) {
        console.log(123);
        if (this.resultpage_price == 0 || this.canWatch) {
          console.log("我是0");
          this.isShow = false;
          this.$parent.isFixed = false;
        } else {
          console.log("我不是0");
          this.isShow = true;
          this.$parent.isFixed = true;
        }
      } else {
        this.isShow = false;
      }
    },
    showContent() {
      const scrollContainer = document.querySelector(".vd-content");
      if (this.showText == "展开全部") {
        this.tmpScrollTop = scrollContainer ? scrollContainer.scrollTop : 0;
        this.showHidContent = !this.showHidContent;
        this.showText = !this.showHidContent ? "展开全部" : "折叠";
      } else {
        if (scrollContainer) {
          scrollContainer.scrollTop = this.tmpScrollTop;
        }
        this.showHidContent = !this.showHidContent;
        this.showText = !this.showHidContent ? "展开全部" : "折叠";
      }
    },
    changeQuote(str) {
      // Object.repl
      const regex = /\’/gm;
      const subst = `"`;
      const result = str.replace(regex, subst);
      return result;
    },
  },
};
</script>

<style scoped>
.readComplete {
  width: 6.29333rem;
  height: 1.2rem;
  background-color: #f5a623;
  border-radius: 0.26667rem;
  line-height: 1.2rem;
  text-align: center;
  color: #fff;
  z-index: 999;
  margin: auto;
}
.buymask {
  height: 100px;
  margin-top: -100px;
  /* margin-bottom: 20px; */
  background: linear-gradient(hsla(0, 0%, 100%, 0.2), #fff);
  background: -webkit-linear-gradient(hsla(0, 0%, 100%, 0.2), #fff);
}
.content-box-hidden {
  height: 5rem;
  overflow: hidden;
}

.container {
  /* z-index: 222; */
  /*height: 500px;*/
  padding: 10px 10px;
  overflow: hidden;
  height: fit-content;
  /*background-color: rgba(208, 226, 255, 1);*/
}

.top {
  height: 30px;
}

.circle-left {
  background-color: rgb(214, 230, 232);
  width: 12px;
  height: 24px;
  border-radius: 0px 12px 12px 0;
  position: absolute;
  left: 0px;
  top: 30px;
  display: inline-block;
}

.circle-right {
  background-color: rgb(214, 230, 232);
  width: 12px;
  height: 24px;
  border-radius: 12px 0 0 12px;
  position: absolute;
  right: 0px;
  top: 30px;
  display: inline-block;
}

.read-more {
  position: absolute;
  z-index: 1;
  bottom: 30px;
  left: 0;
  width: 100%;
  height: 100px;
  margin: 0;
  border-radius: 20px;
  /* "transparent" only works here because == rgba(0,0,0,0) */
  /*background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 97%,rgba(255,255,255,0) 100%);*/
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 80%,
    rgba(255, 255, 255, 0.8) 100%
  );
  pointer-events: none;
}

.back {
  background: white;
  width: 100%;
  /*height: 500px;*/
  position: relative;
  border-radius: 20px;
}

.content-box {
  text-align: justify;
  word-break: break-all;
  padding-left: 20px;
  padding-right: 20px;
  color: #42686e;
  letter-spacing: 1px;
  line-height: 26px;
  font-size: 15px;
  font-weight: 300;
}

.read-more-text {
  position: relative;
  z-index: 2;
  color: grey;
  font-family: SourceHanSansCN-Regular;
  font-size: 0.3rem;
  /*background-color: white;*/
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 50%;
  padding-bottom: 10px;
  padding-top: 10px;
}

.title {
  /* background-image: url("./../../../assets/img/underline.png");
    background-size: 186px 8px;*/
  padding-bottom: 5px;
  margin-bottom: 10px;
  font-family: SourceHanSansCN-Regular;
  background-position: center;
  background-position: bottom;
  background-repeat: no-repeat;
  color: #42686e;
  font-size: 20px;
  text-align: left;
  padding-left: 33px;
}

.para {
  text-indent: 2em;
  /*padding-top: 15px;*/
  padding-bottom: 15px;
  word-wrap: break-word;
}

h1 {
  color: #42686e;
  font-size: 18px;
  letter-spacing: 1px;
  /*padding-top: 15px;*/
  padding-bottom: 5px;
}

html {
  scroll-behavior: smooth;
}

.sub {
  font-size: 16px;
  color: #42686e;
  font-weight: bold;
}
</style>
